<template>
    <div v-if="show">
        <hp6-semantic size-selection="sm">
            Looking for your <a href="/fcp/landing-page">Simplica plan</a>?
        </hp6-semantic>
    </div>
</template>

<script setup>
const { isAuthenticated, context, profile } = useFCPModel()
const { getSimplicaPlans } = usePlan(profile.value, context.value)
const simplicaPlans = getSimplicaPlans()
const show = isAuthenticated.value && simplicaPlans.length > 0
</script>